import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'jsonHighlight', standalone: true })
export class JsonSyntaxHighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(json: string): SafeHtml {
    if (!json) return '';

    let escaped = json
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const highlighted = escaped.replace(
      /("(\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      (match) => {
        let cls = 'jh-number';
        if (/^"/.test(match)) {
          cls = /:$/.test(match) ? 'jh-key' : 'jh-string';
        } else if (/true|false/.test(match)) {
          cls = 'jh-boolean';
        } else if (/null/.test(match)) {
          cls = 'jh-null';
        }
        return `<span class="${cls}">${match}</span>`;
      }
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
